<template>
    <ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
        <template slot="filters">
            <el-form-item label="设备名称" prop="name">
                <el-input v-model="query.name" placeholder="请输入设备名称" clearable @keyup.enter.native="handleSearch" />
            </el-form-item>
            <el-form-item label="设备类型" prop="deviceType">
                <el-select v-model="query.deviceType">
                    <el-option value="FP10" label="FP10"></el-option>
                    <el-option value="EVO" label="EVO"></el-option>
                </el-select>
            </el-form-item>
        </template>
        <template slot="btns" v-if="permission('/content/manual/add')">
            <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">新增说明书</el-button>
        </template>
        <template slot="columns">
            <el-table-column type="index" label="序号" width="100" align="center" />
            <el-table-column label="说明书名称" align="center" prop="name"></el-table-column>
            <el-table-column label="说明书名称（英文）" align="center" prop="enName"></el-table-column>
            <el-table-column label="设备类型" align="center" prop="deviceType"></el-table-column>
            <el-table-column label="设备类型（英文）" align="center" prop="enDeviceType"></el-table-column>
            <el-table-column label="上传时间" align="center" prop="createTime"></el-table-column>
            <el-table-column label="操作" align="center" width="140"
                v-if="permission('/content/manual/edit') || permission('/content/manual/delete')">
                <template slot-scope="{ row }">
                    <el-link v-if="permission('/content/manual/edit')" :underline="false" type="primary"
                        @click="handleEdit(row)">
                        编辑
                    </el-link>
                    <el-link v-if="permission('/content/manual/delete')" :underline="false" type="danger"
                        @click="handleDelete(row)">
                        删除
                    </el-link>
                </template>
            </el-table-column>
        </template>
    </ListPage>
</template>

<script>
import { page, del } from "@/api/content/manual";
import listMixin from '@/mixins/list';
export default {
    data() {
        return {
            // 查询参数
            query: {
                name: "",
                deviceType: "",
                pageNo: 1,
                pageSize: 10,
            },
            deviceTypes: []
        };
    },
    mixins: [listMixin],
    mounted() {

    },
    methods: {
        search() {
            this.loading = true;
            const params = {
                ...this.query,
            };
            page(params).then(({ code, result, message }) => {
                if (code == 200) {
                    this.tableData = result.records;
                    this.total = result.total;
                } else {
                    this.$message.error(message);
                }
                this.loading = false;
            });
        },
        handleAdd() {
            this.$router.push({ path: "/content/manual/form" });
        },
        handleEdit(row) {
            this.$router.push({ path: "/content/manual/form", query: { id: row.id } });
        },
        handleDelete(row) {
            this.$confirm("确定删除该说明书吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                del({ id: row.id }).then(({ code, message }) => {
                    if (code == 200) {
                        this.$message.success("删除成功");
                        this.search();
                    } else {
                        this.$message.error(message);
                    }
                });
            });
        }
    },
};
</script>